import { GetComponentProps, styled } from 'topwrite';
import { ReactComponent as Icon } from '../images/qrcode.svg';
import { QRCodeSVG } from 'qrcode.react';

export default function Menu({ Component }: GetComponentProps<'page:menu:item'>) {

    const tooltip = <ToolTip>
        <QRCodeSVG value={location.href} />
        <p>扫一扫阅读</p>
    </ToolTip>;

    return <Component tooltip={{
        overlay: tooltip,
        placement: 'leftBottom'
    }}>
        <Icon />
    </Component>;
}

const ToolTip = styled.div`
  text-align: center;

  svg {
    padding: 8px;
    background: #FFFFFF;
  }

  p {
    margin-bottom: 0;
  }
`;
